import axios from "axios";
import { I18n } from "react-i18nify";
import { httpRequest, requestTimeOut } from "./config";

import store from "../store";
import { appFlushDatas } from "../actions/appActions";
import errorUtils from "./errorUtils";
let baseURL = "";
if (httpRequest.port) {
	baseURL = `${httpRequest.serverAddress}:${httpRequest.port}${httpRequest.serverPath}`;
} else {
	baseURL = `${httpRequest.serverAddress}/`;
}

// Generic axiosInstance
const axiosInstance = axios.create({
	baseURL: baseURL,
	timeout: requestTimeOut,
	headers: {
		"Content-Type": "application/json",
		Accept: "application/json"
	}
});

let axiosInstanceToken = null;
let axiosDownloadInstanceToken = null;
let axiosUploadInstanceToken = null;
let axiosCancelToken = axios.CancelToken;

// Function who follow generic api contract
const resolvePromise = (promise, resolve, reject) => {
	promise
		.then(function(res) {
			if (
				res.data.error &&
				res.data.error.code &&
				res.data.error.code === -3
			) {
				errorUtils.dispatchErrorWithTimeout(
					I18n.t("errorMessage.tokenTimeOut")
				);
				console.warn("FLUSH DATA - error api", res.data.error);
				store.dispatch(appFlushDatas());
				reject(res.data.error);
			} else if (res.data.error && res.data.error.code) {
				reject(res.data.error);
			} else if (typeof res.data.result !== "undefined")
				resolve(res.data.result);
			else {
				reject(res.data.error);
			}
		})
		.catch(function(err) {
			errorUtils.dispatchErrorWithTimeout(
				I18n.t("errorMessage.serverError")
			);
			reject(err);
		});
};

const resolveDownloadPromise = (promise, resolve, reject) => {
	promise
		.then(function(res) {
			if (res.status === 200) resolve(res.data);
			else reject(res);
		})
		.catch(function(err) {
			reject(err);
		});
};

const initAxiosInstanceToken = token => {
	axiosInstanceToken = axios.create({
		baseURL: baseURL,
		timeout: requestTimeOut,
		maxContentLength: 100000000000,
		headers: {
			"Content-Type": "application/json",
			Accept: "*/*",
			"uploader-token": token
		}
	});
	axiosDownloadInstanceToken = axios.create({
		baseURL: baseURL,
		timeout: requestTimeOut,
		responseType: "arraybuffer",
		maxContentLength: 100000000000,
		headers: {
			"Content-Type": "application/json",
			Accept: "*/*",
			"uploader-token": token
		}
	});
	axiosUploadInstanceToken = axios.create({
		baseURL: baseURL,
		timeout: requestTimeOut,
		headers: {
			"uploader-token": token
		}
	});
};

export {
	axiosInstance,
	axiosInstanceToken,
	axiosDownloadInstanceToken,
	axiosUploadInstanceToken,
	resolveDownloadPromise,
	resolvePromise,
	initAxiosInstanceToken,
	axiosCancelToken
};



// WEBPACK FOOTER //
// ./src/utils/axios.js